import * as ScoreType from "../../../../../../constants/ScoreType";
import { Map } from "immutable";
export function getBasketballScores(scores) {
    var defaultScore = new Map({ score1: 0, score2: 0 });
    var firstQuarterScore = (scores.find(function (score) { return score.get("type") === ScoreType.FirstPeriod; }) || defaultScore).toJS();
    var secondQuarterScore = (scores.find(function (score) { return score.get("type") === ScoreType.SecondPeriod; }) || defaultScore).toJS();
    var thirdQuarterScore = (scores.find(function (score) { return score.get("type") === ScoreType.ThirdPeriod; }) || defaultScore).toJS();
    var fourthQuarterScore = (scores.find(function (score) { return score.get("type") === ScoreType.FourthPeriod; }) || defaultScore).toJS();
    var overtimeScore = (scores.find(function (score) { return score.get("type") === ScoreType.Overtime; }) || defaultScore).toJS();
    var ballPossession = (scores.find(function (score) { return score.get("type") === ScoreType.BallPossession; }) || defaultScore).toJS();
    var homeTeamPossession;
    var awayTeamPossession;
    var team = ballPossession ? ballPossession.team : undefined;
    if (team !== undefined) {
        if (team === 1) {
            homeTeamPossession = true;
            awayTeamPossession = false;
        }
        else if (team === 2) {
            homeTeamPossession = false;
            awayTeamPossession = true;
        }
    }
    return {
        firstTeamTotal: ((firstQuarterScore.score1 || 0) +
            (secondQuarterScore.score1 || 0) +
            (thirdQuarterScore.score1 || 0) +
            (fourthQuarterScore.score1 || 0) +
            (overtimeScore.score1 || 0)) || undefined,
        secondTeamTotal: ((firstQuarterScore.score2 || 0) +
            (secondQuarterScore.score2 || 0) +
            (thirdQuarterScore.score2 || 0) +
            (fourthQuarterScore.score2 || 0) +
            (overtimeScore.score2 || 0)) || undefined,
        homeTeamPossession: homeTeamPossession,
        awayTeamPossession: awayTeamPossession
    };
}



// WEBPACK FOOTER //
// ./src/components/grid/common/sportsGrid/statistics/mainScores/basketball.js